/**
 * Rating tooltip texts for course rating explanations
 * Used across components to provide consistent explanations of what each rating category means
 */
export const RATING_TOOLTIP_TEXTS = {
  topic: "Were the topics covered what you expected from the course sheet?",
  lecture: "How well was the lecture structured?",
  materials: "How well did the provided course materials support your education?",
  professor: "How well did the professor perform?",
  exam: "Was the exam fair?",
  workload: "Was the workload appropriate for the ECTS?",
};

export const EXERCISE_GROUP_TOOLTIP_TEXT = "Exercise groups often switch teaching assistants between semesters. The ratings shown may reflect previous instructors and might not apply to the current teaching staff.";